import React, {useState} from 'react';

import Loading from './Loading';
import { FaDownload } from 'react-icons/fa';

const ButtonDownload = ({obj, downloadMethod, nameKey, type}) => {

    const [load, isLoad] = useState(false);

    const onClick = async () =>{
        isLoad(true);
        const res = await downloadMethod(obj);       
        const a = document.createElement("a");         
        a.href = `data:${type};base64,${res[nameKey]}`; //Image Base64 Goes here
        a.download = obj; //File name Here
        a.click(); //Downloaded file
        isLoad(false);
    }

    return ( 
        <>
            {load ? <Loading/> : 
                <button className="btn btn-link" 
                    onClick={onClick}
                >
                    <FaDownload />
                </button>
            }
       </>
     );
}
 
export default ButtonDownload;